export default {
    cancel: 'Cancelar',
    changePassword: 'Cambiar contraseña',
    rotatePassword: 'Por políticas de seguridad la contraseña debe ser cambiada',
    confirmNewPasswordLabel: 'Confirmar nueva contraseña',
    newPassword: 'Nueva contraseña',
    newPasswordLabel: 'Ingresar nueva contraseña',
    currentPassword: 'Contraseña actual',
    passwordMinLength: 'Mínimo {n} caracteres',
    passwordLowerCase: 'Al menos 1 letra minúscula',
    passwordUpperCase: 'Al menos 1 letra mayúscula',
    specialCharacter: 'Al menos 1 caracter especial  {n}',
    number: 'Al menos 1 número',
    updateSuccess: 'La contraseña ha sido actualizada' 
  }
  